import { FC } from 'react'
import { Card, Stack, Typography } from '@mui/material'
import { IViewGridItemProps } from './types'

export const GridItemDefault: FC<IViewGridItemProps<any>> = (props) => {
  const content = JSON.stringify(props.value, null, 2)
  return (
    <Card variant='outlined' sx={{ height: '100%', width: '100%', overflow: 'hidden', p: 1, boxSizing: 'border-box!important' }} title={content}>
      <Stack spacing={1}>
        <Typography>Index: {props.index}</Typography>
        <Typography variant='body2' sx={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          Data: {content}
        </Typography>
      </Stack>
    </Card>
  )
}
